import React from "react";

import { TypeKey } from "../components/EquivalentCard";
import { Text } from "../../Text";

export const getInfoCopy = (typeKey: TypeKey) => {
  let text = (
    <>
      <Text mb>
        Our long haul flight of choice is London to San Francisco, a distance of
        8,619.80 km (calculated using{" "}
        <Link
          href="https://www.distance.to/San-Francisco/London"
          text="Distance To"
        />
        ).
      </Text>
      <Text mb>
        Using the UK government’s{" "}
        <Link
          href="https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2017"
          text="greenhouse gas report"
        />{" "}
        from 2017 This flight emits 0.15119 kg per km of CO<sub>2</sub> per
        person seated in economy class.
      </Text>
      <Text mb>
        This means the total flight emissions for one person is 1303.23 kg (1.3
        tonnes).
      </Text>
    </>
  );

  if (typeKey === "ice") {
    text = (
      <Text mb>
        A 2016{" "}
        <Link
          href="https://science.sciencemag.org/content/354/6313/747"
          text="research paper"
        />{" "}
        published in Novembers issue of Science Magazine, found that the loss of
        Arctic sea ice had a linear relationship to CO<sub>2</sub> emissions.
        This rate is 3 ± 0.3 square metres per tonne of CO<sub>2</sub>.
      </Text>
    );
  } else if (typeKey === "car") {
    text = (
      <Text mb>
        The US Environmental Protection Agency’s{" "}
        <Link
          href="https://www.epa.gov/energy/greenhouse-gas-equivalencies-calculator"
          text="carbon emissions calculator"
        />{" "}
        estimates that 2547 miles (4099 km) emits 1 tonne of CO<sub>2</sub>.
      </Text>
    );
  }

  return text;
};

const Link = ({ href, text }: { href: string; text: string }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    title="Open website (new tab)"
    className="link"
  >
    {text}
  </a>
);
